/**
 * Pure decision for the dashboard verify feature flag — no `import.meta`, so it
 * is unit-testable under the dashboard's CJS jest runner. The runtime wrapper
 * that reads Vite's `import.meta.env` lives in `verifyFlag.ts`.
 */

export interface VerifyFlagEnv {
  DEV?: boolean;
  VITE_ENABLE_VERIFY?: string;
}

/**
 * Verify UI is enabled in dev, or when the
 * explicit prod override env var is exactly the string "true".
 */
export function computeVerifyEnabled(env: VerifyFlagEnv | undefined): boolean {
  if (!env) return false;
  return env.DEV === true || env.VITE_ENABLE_VERIFY === 'true';
}
